import type { SelfCheckoutStep } from "@shared/selfCheckoutFlow/buildSteps";

interface StepsProps {
  steps: SelfCheckoutStep[];
  currentStep: number;
}

/**
 * Slot marker for CheckoutProgressHeader — renders nothing itself; the root
 * reads its props and owns the responsive dual-placement of the stepper.
 */
const Steps = (_unusedProps: StepsProps) => null;

export { Steps };
export type { StepsProps };
